import { Outlet } from "react-router";

import PaymentListScreen from "./screens/PaymentListScreen";

export const paymentRoutes = [
    {
        path: "payments",
        handle: { breadcrumb: "payments:paymentListScreen.title" },
        element: <Outlet />,
        children: [{ index: true, element: <PaymentListScreen /> }],
    },
];
